import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function BWModal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button className="btn-outline-light" variant="danger" size='sm' onClick={handleShow}>
        Info
      </Button>

      <Modal show={show} onHide={handleClose} animation={true} size='lg' aria-labelledby='contained-modal-title-vcenter' centered style={{backgroundColor:'black'}}>
        <Modal.Header  style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D"}}>
          <Modal.Title style={{backgroundColor:'black', border:'none', color:'white'}}>Blood Work & Lab Interpretation</Modal.Title>
        </Modal.Header>
        <Modal.Body  style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D", color:'white'}}>
            <h2>
              <u>                
                Custom Lab Panel
              </u>
            </h2>
            <p>
               Comprehensive testing built around your specific goals — including hormone, thyroid, metabolic, lipid, and nutrient markers.
            </p>
            <h2>
              <u>                
                Third-Party Lab Testing
              </u>
            </h2>
            <p>
              We’ve partnered with Marek Health, a leader in cutting-edge health optimization. You’ll purchase your lab panel securely online, then complete your draw at one of many nearby Labcorp locations. Results are typically available within a few days — with no insurance, copays, referrals, or medical system hassles. Fast, direct, and fully transparent.
            </p>
            <h2>
              <u>                
                Detailed Interpretation Report
              </u>
            </h2>
            <p>Receive an in-depth, easy-to-understand breakdown explaining each marker, what’s optimal for health, longevity, and performance, and where targeted improvements can be made.</p>
            <h2>
              <u>                
                Lifestyle & Supplement Recommendations
              </u>
            </h2>
            <p>Get precise, science-backed strategies for improving your biomarkers through nutrition, training, supplementation, and recovery adjustments — all designed to enhance performance and well-being.</p>
            <h2>
              <u>                
                Follow-Up Review (Optional)
              </u>
            </h2>
            <p>Schedule a personalized follow-up to assess progress and fine-tune your protocol based on updated lab results.</p>
            <p>This service bridges the gap between medical insight and performance coaching, empowering you to make informed, data-driven decisions about your health and longevity.</p>
            <h4 className='pt-3'>Understand your body. Optimize your performance.</h4> 
            <h3>Reach your APEX.</h3>
        
        </Modal.Body>
        <Modal.Footer style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D"}}>
          <h5 className='col' style={{color:"white"}}>
            Price: $100.00
          </h5>
          <Button  variant="danger"  onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BWModal;